import { render, staticRenderFns } from "./ProcessReturn.vue?vue&type=template&id=7a8639e7&scoped=true&"
import script from "./ProcessReturn.vue?vue&type=script&lang=js&"
export * from "./ProcessReturn.vue?vue&type=script&lang=js&"
import style0 from "./ProcessReturn.vue?vue&type=style&index=0&id=7a8639e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8639e7",
  null
  
)

export default component.exports